import React, {
  ComponentType
} from 'react'
import { Header } from 'semantic-ui-react'
// Local
import { shouldRenderReskin2025 } from '../../constant'
// import { z } from 'zod'

// const propsSchema = z.object({
//   left: z.any().optional().refine(
//     val => val === undefined || isValidElement(val as unknown),
//     { message: '\'left\' must be a valid React element' }
//   ),
//   center: z.any().optional().refine(
//     val => val === undefined || isValidElement(val as unknown),
//     { message: '\'left\' must be a valid React element' }
//   ),
//   right: z.any().optional().refine(
//     val => val === undefined || isValidElement(val as unknown),
//     { message: '\'left\' must be a valid React element' }
//   ),
//   isReskinEnabled: z.boolean().optional().default(true)
// })

type Props = {
  left?: JSX.Element | string
  center?: JSX.Element | string
  right?: JSX.Element | string
}

const SafeHeader = Header as unknown as ComponentType<any>

function SubHeader(
  props: Props
): JSX.Element {
  const {
    left,
    center,
    right
  } = props
  const reskinClassName = shouldRenderReskin2025
    ? ' reskin'
    : ''
  return (
    <SafeHeader
      id="sub-header"
      attached="top"
      block
      className={ `main-sub-header${reskinClassName}` }
    >
      <div className="sub-left">{ left }</div>
      <div className="sub-center">{ center }</div>
      <div className="sub-right">{ right }</div>
    </SafeHeader>
  )
}

export default SubHeader
